import React from 'react';
import { ClimbingBoxLoader } from 'react-spinners';

const Loading = () => {

    return (
        <div className="d-flex justify-content-center align-items-center my-3 py-5">
            <ClimbingBoxLoader size={20} />
        </div>

    );
};

export default Loading;